export default "__VITE_ASSET__ddd273ac__"